<div class="container-fluid">
	<h1 class="my-3 text-capitalize">{{item_points.id ? 'Actualizar':'Agregar'}} Puntos de articulo</h1>
	<form ngNativeValidate (submit)="save($event)">
		<div class="card p-3">
			<div class="row p-3">
				<div class="col-6 col-md-4 form-group">
					<label class="">Articulo {{item_points.item_id}}</label>
					<app-search-items (item_selected)="onItemInfoSelected($event)" [reset_on_search]="false" *ngIf="!item_points.item_id"></app-search-items>
					<div class="form-control" *ngIf="item_points.item_id">{{item_info | itemName}}</div>
				</div>
				<div class="col-6 col-md-4 form-group">
					<label class="">Type</label>
					<select name="type" [(ngModel)]="item_points.type" class="form-control" required>
						<option value="">Seleccionar</option>
						<option value="AMOUNT">Cantidad</option>
						<option value="PERCENT">Porcentaje Consumo</option>
					</select>
				</div>
				<div class="col-6 col-md-4 form-group">
					<label class="">{{item_points.type =='AMOUNT'?'Puntos por articulo':'Porcentaje Por consumo'}}</label>
					<input type="number" name="qty" [(ngModel)]="item_points.qty" class="form-control" min="1" required>
				</div>
			</div>
			<div class="row p-3">
				<div class="col-12 text-right">
					<button type="submit"  [disabled]="is_loading" class="btn btn-primary">Guardar</button>
				</div>
			</div>
		</div>
	</form>
</div>
